import type { CheckoutSite } from '@trmediaab/zebra-types/trhub';

const production: Record<CheckoutSite, string> = {
  jokersystemet: 'https://www.jokersystemet.se',
  jokersystemet_no: 'https://www.jokersystemet.no',
  spelvarde: 'https://www.spelvarde.se',
  storavinster: 'https://www.storavinster.se',
  travfakta: 'https://www.travfakta.se',
  travronden: 'https://www.travronden.se',
  travronden_spel: 'https://www.travrondenspel.se',
  travogat: 'https://www.travogat.se',
};

const staging: Record<CheckoutSite, string> = {
  jokersystemet: 'https://joker.trdev.se',
  jokersystemet_no: 'https://jokerno.trdev.se',
  spelvarde: 'https://spelvarde.trdev.se',
  storavinster: 'https://test.storavinster.se',
  travfakta: 'https://test.travfakta.se',
  travronden: 'https://travronden.trdev.se',
  travronden_spel: 'https://travrondenspel.trdev.se',
  travogat: 'https://test.travogat.se',
};

export function getSiteBaseUrl(site: CheckoutSite) {
  return process.env.NODE_ENV === 'development'
    ? staging[site]
    : production[site];
}

export function pathToSiteUrl(site: CheckoutSite, path: string) {
  if (/^https?:\/\/[^/]+/.test(path)) {
    return path;
  }

  return getSiteBaseUrl(site) + path;
}

export function getSiteLinkText(site: CheckoutSite) {
  switch (site) {
    case 'jokersystemet':
    case 'jokersystemet_no':
      return 'Till Jokersystemet';
    case 'spelvarde':
      return 'Till Spelvärde';
    case 'storavinster':
      return 'Till Storavinster';
    case 'travfakta':
      return 'Till Travfakta';
    case 'travronden':
      return 'Till Travronden';
    case 'travronden_spel':
      return 'Till Travronden Spel';
    case 'travogat':
      return 'Till Travögat';
    default:
      return null;
  }
}
